var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEstelle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 214 341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #000;\n        stroke-width: 3.4px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill: none;\n      }\n\n      .cls-1, .cls-4, .cls-5 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        stroke: #22278c;\n        stroke-width: 3px;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        stroke: #fff;\n      }\n\n      .cls-6 {\n        fill: #f4b497;\n      }\n\n      .cls-7 {\n        fill: #414a4c;\n      }\n\n      .cls-8 {\n        fill: #373db0;\n      }\n\n      .cls-9 {\n        fill: #ee927e;\n      }\n\n      .cls-10 {\n        fill: #f6c09c;\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-4 {\n        stroke: #033040;\n        stroke-width: 24.93px;\n      }\n\n      .cls-13 {\n        fill: #fff;\n      }\n\n      .cls-14 {\n        fill: #000d19;\n      }\n\n      .cls-15 {\n        fill: #f8c79d;\n      }\n\n      .cls-16 {\n        fill: #073f4a;\n      }\n\n      .cls-17 {\n        fill: #556ec9;\n      }\n\n      .cls-18 {\n        fill: #fa98be;\n      }\n\n      .cls-5 {\n        stroke: #000d19;\n        stroke-width: 2.27px;\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-20 {\n        fill: #002131;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M74.12,211.29h24.34c7.19,0,13.02,5.83,13.02,13.02v4.3c0,3.88-3.15,7.02-7.02,7.02h-36.34c-3.88,0-7.02-3.15-7.02-7.02v-4.3c0-7.19,5.83-13.02,13.02-13.02Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M130.11,174.03h-19.56c-4.04,0-6.4-4.56-4.07-7.85l1.43-2.02c6.06-8.57,18.78-8.57,24.84,0l1.43,2.02c2.33,3.3-.03,7.85-4.07,7.85Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M72.56,174.03h19.56c4.04,0,6.4-4.56,4.07-7.85l-1.43-2.02c-6.06-8.57-18.78-8.57-24.84,0l-1.43,2.02c-2.33,3.3.03,7.85,4.07,7.85Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 114,
    cy: 288,
    rx: 77,
    ry: 30
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.24,100.52h40.67c11.81,0,21.4,9.59,21.4,21.4v103.19c0,20.04-16.27,36.3-36.3,36.3h-26.52c-20.04,0-36.3-16.27-36.3-36.3v-87.53c0-20.45,16.61-37.06,37.06-37.06Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 103.79,
    y: 207.55,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(317.67 393.48) rotate(153.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 119.84,
    y: 239.69,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(362.44 447.22) rotate(153.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 141.9,
    cy: 280.46,
    r: 14.34
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 69.08,
    y: 232.86,
    width: 34.43,
    height: 26.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M74.12,211.29h24.34c7.19,0,13.02,5.83,13.02,13.02v4.3c0,3.88-3.15,7.02-7.02,7.02h-36.34c-3.88,0-7.02-3.15-7.02-7.02v-4.3c0-7.19,5.83-13.02,13.02-13.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M72.63,211.29h32.49v5.77c0,4.73-3.84,8.57-8.57,8.57h-15.35c-4.73,0-8.57-3.84-8.57-8.57v-5.77h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M77.14,251.67h18.3c12.37,0,22.42,10.05,22.42,22.42v9.49h-63.14v-9.49c0-12.37,10.05-22.42,22.42-22.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 69.08,
    y: 248.66,
    width: 34.43,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 69.08,
    y: 234.18,
    width: 34.43,
    height: 8.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M181.24,277.09l-9.16,3.48c-8.28,3.14-17.14-2.97-17.14-11.83h0c0-8.86,8.86-14.97,17.14-11.83l9.16,3.48c7.69,2.92,7.69,13.79,0,16.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M157.66,262.82h15.23v6.67c0,2.85-2.31,5.16-5.16,5.16h-4.91c-2.85,0-5.16-2.31-5.16-5.16v-6.67h0Z",
    transform: "translate(-103.45 434.01) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M142.63,268.73c0,8.01-6.49,14.5-14.5,14.5h-41.11c-8.01,0-14.5-6.49-14.5-14.5s6.49-14.5,14.5-14.5h41.11c8.01,0,14.5,6.49,14.5,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M166.06,283.23h-41.11c-8.01,0-14.5-6.49-14.5-14.5s6.49-14.5,14.5-14.5h41.11v29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.82,252.66c-.71-.71-1.86-.71-2.57,0s-.71,1.86,0,2.57l2.57,2.57,2.57-2.57c.71-.71.71-1.86,0-2.57s-1.86-.71-2.57,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.75,252.66c-.71-.71-1.86-.71-2.57,0s-.71,1.86,0,2.57l2.57,2.57,2.57-2.57c.71-.71.71-1.86,0-2.57s-1.86-.71-2.57,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.88,252.66c-.71-.71-1.86-.71-2.57,0s-.71,1.86,0,2.57l2.57,2.57,2.57-2.57c.71-.71.71-1.86,0-2.57s-1.86-.71-2.57,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M88.88,263.51h4.6v11.24c0,2.54-2.06,4.6-4.6,4.6h0v-15.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M82,91.73h13.74c21.52,0,38.99,17.47,38.99,38.99v29.67c0,8.75-7.1,15.85-15.85,15.85h-60.03c-8.75,0-15.85-7.1-15.85-15.85v-29.67c0-21.52,17.47-38.99,38.99-38.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M76.67,119.77h38.77c11.66,0,21.12,9.47,21.12,21.12v39.74c0,18.71-15.19,33.9-33.9,33.9h-13.21c-18.71,0-33.9-15.19-33.9-33.9v-39.74c0-11.66,9.47-21.12,21.12-21.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M166.62,292.88l-9.16,3.48c-8.28,3.14-17.14-2.97-17.14-11.83h0c0-8.86,8.86-14.97,17.14-11.83l9.16,3.48c7.69,2.92,7.69,13.79,0,16.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M143.04,278.61h15.23v6.67c0,2.85-2.31,5.16-5.16,5.16h-4.91c-2.85,0-5.16-2.31-5.16-5.16v-6.67h0Z",
    transform: "translate(-133.86 435.18) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M124.83,284.52c0,8.01-6.49,14.5-14.5,14.5h-41.11c-8.01,0-14.5-6.49-14.5-14.5s6.49-14.5,14.5-14.5h41.11c8.01,0,14.5,6.49,14.5,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M151.44,299.02h-41.11c-8.01,0-14.5-6.49-14.5-14.5s6.49-14.5,14.5-14.5h41.11v29Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 49.38,
    y: 222.79,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(100.96 -3.04) rotate(22.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 35.48,
    y: 255.92,
    width: 17.33,
    height: 53.28,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(112.7 4.91) rotate(22.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 31.71,
    cy: 297.54,
    r: 14.34
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 76.59,
    y: 196.16,
    width: 19.4,
    height: 22.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M103.38,169.16l7.34,20.73c.63,1.77-.69,3.64-2.57,3.64h-3.27c-2.03,0-3.68-1.65-3.68-3.68v-20.31c0-1.26,1.75-1.56,2.17-.37Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M130.11,174.03h-19.56c-4.04,0-6.4-4.56-4.07-7.85l1.43-2.02c6.06-8.57,18.78-8.57,24.84,0l1.43,2.02c2.33,3.3-.03,7.85-4.07,7.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 117.93,
    y: 147.37,
    width: 14.31,
    height: 24.01,
    rx: 7.15,
    ry: 7.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 116.4,
    y: 163.49,
    width: 6.15,
    height: 11.21,
    rx: 3.07,
    ry: 3.07
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.05,166.93s4.82-9.2,14.29-9.2c10.31,0,14.28,9.2,14.28,9.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 133,
    y1: 157.45,
    x2: 129.76,
    y2: 160.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128.05,
    y1: 154.46,
    x2: 126,
    y2: 158.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 136.94,
    y1: 161.17,
    x2: 133.26,
    y2: 164.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M72.56,174.03h19.56c4.04,0,6.4-4.56,4.07-7.85l-1.43-2.02c-6.06-8.57-18.78-8.57-24.84,0l-1.43,2.02c-2.33,3.3.03,7.85,4.07,7.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 79.56,
    y: 147.55,
    width: 14.31,
    height: 24.01,
    rx: 7.15,
    ry: 7.15,
    transform: "translate(173.43 319.11) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 77.87,
    y: 164.17,
    width: 6.15,
    height: 11.21,
    rx: 3.07,
    ry: 3.07,
    transform: "translate(161.89 339.56) rotate(-180)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.63,166.93s-4.82-9.2-14.29-9.2c-10.31,0-14.28,9.2-14.28,9.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.68,
    y1: 157.45,
    x2: 72.91,
    y2: 160.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 74.62,
    y1: 154.46,
    x2: 76.67,
    y2: 158.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 65.73,
    y1: 161.17,
    x2: 69.41,
    y2: 164.17
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M130.09,168.52h11.48v2.31c0,7.24-5.88,13.12-13.12,13.12h0c-2.77,0-5.02-2.25-5.02-5.02v-3.76c0-3.67,2.98-6.66,6.66-6.66Z",
    transform: "translate(265 352.47) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M65.63,168.52h0c7.24,0,13.12,5.88,13.12,13.12v2.31h-11.48c-3.67,0-6.66-2.98-6.66-6.66v-3.76c0-2.77,2.25-5.02,5.02-5.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 66.9,
    cy: 181.45,
    r: 7.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.51,125.95h-9.16c-15.4,0-27.88,12.48-27.88,27.88v87.59"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 135.77,
    cy: 181.45,
    r: 7.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M101.85,201.44s-1.72-3.77-6.99-6.04-9.43-.48-9.43-.48c0,0,1.52,4.1,7.15,6.38,4.02,1.63,9.27.15,9.27.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.03,125.95h9.16c15.4,0,27.88,12.48,27.88,27.88v87.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M83.31,192.35c2.44,7.8,10.74,12.15,18.54,9.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 88.88,
    y1: 270.02,
    x2: 151.44,
    y2: 270.02
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstelle2);
export default __webpack_public_path__ + "static/media/estelle_2.459a64da1c291fa61ce69032f56268ab.svg";
export { ForwardRef as ReactComponent };